import styled from "styled-components";

const Style = {
    Container: styled.span`
        display: flex;
        align-items: center;
        gap: 4px;
        cursor: pointer;
        color: inherit;
    `,
    
    SortIcon: styled.img`
        width: 16px;
        height: 16px;
        opacity: ${({ $isActive }) => $isActive ? 1 : 0.5};
        transform: ${({ $direction }) => $direction === 'DESC' ? 'rotate(180deg)' : 'none'};
        transition: all 0.2s ease;
        cursor: pointer;
    `
};

export default Style;
